import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function List() {
    const profileFilter = chooseProfileFilter();
    const { keys } = useKeysStore();
    const pathFrontEnd = '/balances/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}demonstratives/delete`,
        endpoint: config.endpoints.backend + 'demonstratives/getall'
    };

    const pathsForm = {
        endpointSave: config.endpoints.backend + 'demonstratives/save',
        endpointGetById: config.endpoints.backend + 'demonstratives/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id;
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'period',
                name_start: 'publish_start',
                name_end: 'publish_end',
                type: 'date_period',
                label: 'Data',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Balanços',
        labelTitleButtonAdd: 'Incluir novo Balanço',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: !profileFilter.pdc_entity_id ? filters : null,
        filter: {
            ...profileFilter,
            pdc_demonstrative_type_id:
                keys?.default_foreign_key?.pdc_demonstrative_types?.balance
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade',
                width: '20%'
            },
            {
                name: 'publish_date',
                label: 'Data Base'
            },
            {
                name: 'obs',
                label: 'Descrição'
            },
            {
                name: 'created_at',
                label: 'Data de Criação'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        validateOnChange: true,
        hiddenValues: {
            pdc_demonstrative_type_id:
                keys?.default_foreign_key?.pdc_demonstrative_types?.balance,
            ...hiddenValues
        },
        fields: [
            !hiddenValues.pdc_entity_id
                ? {
                      name: 'pdc_entity_id',
                      type: 'select',
                      label: 'Entidade',
                      options: [],
                      optionsEndpoint: {
                          endpoint: pathsForm.endpointGetAllEntities,
                          label: 'corporate_name',
                          value: 'id',
                          params: {
                              filter: {
                                  ...profileFilter
                              }
                          }
                      },
                      validations: {
                          required: false
                      },
                      columnSize: 12
                  }
                : {},
            {
                name: 'publish_date',
                type: 'date',
                label: 'Data Base',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'obs',
                type: 'text',
                label: 'Descrição',
                validations: {
                    required: false
                },
                maxLength: 100
            },
            {
                name: 'file',
                type: 'fileS3',
                limitFileSize: keys?.limitFileSizeDefault,
                label: 'Arquivo',
                validations: {
                    required: true
                },
                columnSize: 12
            }
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Balanço'
    };

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
